type GlyphProps = {
  /** The `d` of a single 24×24 stroked path. */
  d: string;
  size?: number;
};

/**
 * A decorative line icon drawn inside a glass card. The empty-state devices use
 * the exact prototype paths rather than the app icon set so the illustrations
 * match pixel for pixel; they are always `aria-hidden`.
 */
export function Glyph({ d, size = 20 }: GlyphProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}
